<template>
  <b-card class="analysis-report-card">
    <div class="title d-flex justify-content-between">
      <div class="font-weight-bold">{{ $t(item.title) }}</div>
      <div class="d-flex justify-content-center align-items-center" :class="`icon-${item.color}`">
        <i class="mc-icon icon-outline_rupiah" />
      </div>
    </div>
    <div class="total-amount">
      {{ total(item.total) }} <span class="unit">{{ $t('dashboard.text.rupiah') }}</span>
    </div>
  </b-card>
</template>
<script>
import { Helper } from '@/mixin/helper'
export default {
  props: {
    item: {
      type: Object,
    },
  },
  methods: {
    total(val) {
      return Helper.methods.localeThousandFormat(val)
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-report__analysis-cost {
  .analysis-report-card {
    .title {
      div:nth-child(2) {
        width: 32px;
        height: 32px;
        border-radius: 16px;
        .mc-icon {
          font-size: 20px;
          &::before {
            color: $white !important;
          }
        }
      }
      .icon-blue {
        background: $cyan;
      }
      .icon-green {
        background: $green;
      }
    }
    .total-amount {
      font-size: 24px;
      font-weight: bold;
    }
    .unit {
      font-size: 12px;
      font-weight: normal;
    }
  }
}
</style>